import type { FieldConfig } from '@/components/TimesheetReports/FieldSelector';
import type { PostingStatus } from '@/utils/PostingLog/types';

export const STATUS_OPTIONS: { value: PostingStatus; label: string }[] = [
  { value: 'Posted', label: 'Posted' },
  { value: 'Failed', label: 'Failed' },
  { value: 'Pending', label: 'Pending' },
];

export const STATUS_CONFIG: Record<PostingStatus, { badgeClass: string }> = {
  Posted:  { badgeClass: 'bg-success-100 text-success-800 dark:bg-success-900/40 dark:text-success-300' },
  Failed:  { badgeClass: 'bg-error-100 text-error-800 dark:bg-error-900/40 dark:text-error-300' },
  Pending: { badgeClass: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300' },
};

export const POSTING_DEFAULT_COLUMNS: FieldConfig[] = [
  { id: 'timesheetId',          label: 'Timesheet',    visible: true,  order: 0, category: 'Reference' },
  { id: 'employeeName',         label: 'Employee',     visible: true,  order: 1, category: 'People' },
  { id: 'transactionDate',      label: 'Date',         visible: true,  order: 2, category: 'Time Period' },
  { id: 'projectName',          label: 'Project',      visible: true,  order: 3, category: 'Project' },
  { id: 'costCentreName',       label: 'Cost Centre',  visible: true,  order: 4, category: 'Finance' },
  { id: 'quantity',             label: 'Hours',        visible: true,  order: 5, category: 'Hours' },
  { id: 'price',                label: 'Rate',         visible: true,  order: 6, category: 'Finance' },
  { id: 'upliftValue',          label: 'Uplift',       visible: true,  order: 7, category: 'Finance' },
  { id: 'status',               label: 'Status',       visible: true,  order: 8, category: 'Status' },
  { id: 'externalTransactionId', label: 'ERP Ref',     visible: true,  order: 9, category: 'Reference' },
  { id: 'errorMessage',         label: 'Error',        visible: true,  order: 10, category: 'Details' },
];

export const PAGE_SIZE = 50;
